var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#76CBA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6278 23.8172C19.8211 24.0555 18.8678 24.1655 17.7494 24.1655H12.2494C11.1311 24.1655 10.1778 24.0555 9.37109 23.8172C9.57276 21.4339 12.0203 19.5547 14.9994 19.5547C17.9786 19.5547 20.4261 21.4339 20.6278 23.8172Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7487 5.83398H12.2487C7.66536 5.83398 5.83203 7.66732 5.83203 12.2507V17.7507C5.83203 21.2157 6.87703 23.1131 9.37037 23.819C9.57203 21.4356 12.0195 19.5565 14.9987 19.5565C17.9779 19.5565 20.4254 21.4356 20.627 23.819C23.1204 23.1131 24.1654 21.2157 24.1654 17.7507V12.2507C24.1654 7.66732 22.332 5.83398 17.7487 5.83398ZM14.9987 16.9898C13.1837 16.9898 11.717 15.514 11.717 13.699C11.717 11.884 13.1837 10.4173 14.9987 10.4173C16.8137 10.4173 18.2804 11.884 18.2804 13.699C18.2804 15.514 16.8137 16.9898 14.9987 16.9898Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2821 13.6977C18.2821 15.5127 16.8154 16.9885 15.0004 16.9885C13.1854 16.9885 11.7188 15.5127 11.7188 13.6977C11.7188 11.8827 13.1854 10.416 15.0004 10.416C16.8154 10.416 18.2821 11.8827 18.2821 13.6977Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCustomerIcon);
export default __webpack_public_path__ + "static/media/ActiveCustomerIcon.49a41e3619dadacef96df9f4e1ffb6bf.svg";
export { ForwardRef as ReactComponent };